import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as categoryAction from './../../../../../actions/categoryAction';
import CategoryDetail from './CategoryDetail';

const mapStateToProps = state => {
    return {
        categoryState: state.categoryReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getCategoryDetail: (id) => dispatch(categoryAction.getCategoryDetail(id)),
        setCategoryDetail: (category) => dispatch(categoryAction.setCategoryDetail(category)),
        updateCategoryDetail: (category) => dispatch(categoryAction.updateCategoryDetail(category)),
        createCategoryDetail: (category) => dispatch(categoryAction.createCategoryDetail(category)),
        createCategoryTranslate: (category, language) => dispatch(categoryAction.createCategoryTranslate(category, language)),
        updateCategoryTranslate: (category, language) => dispatch(categoryAction.updateCategoryTranslate(category, language)),
        deleteCategoryTranslate: (category, refreshParams) => dispatch(categoryAction.deleteCategoryTranslate(category, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CategoryDetail));
